const { default: axios } = require("axios")
const { default: store } = require("../../../s/login")
// const { resolve } = require("core-js/fn/promise")
exports.install = function(Vue, options){
    Vue.prototype.yet = {}
    Vue.prototype.yet.data = async (name,opt={})=>{
        let base_data_url = '/api/data'
        let method = 'get'
        let target = 'data'
        // let mod = opt.mod
        let scope  = opt.scope || 'all'
        let range = opt.range || 'all'
        let condition = opt.condition || 'all'
        let data = opt.data || null
        let query = null;
        let params = opt.params || ""
        if(opt.query){
            query = `json=${JSON.stringify(opt.query)}`
        }
        let sort = opt.sort || 'default';
        let format = opt.format || 'friendly';
        let url = `${base_data_url}/${name}/${scope}/${range}/${query || condition}/${sort}.${format}?${params}&${Math.random()}`
        if(opt.out){
            url = `${base_data_url}/${name}/${scope}/${range}/${query || condition}/${opt.out}/${sort}.${format}?${params}&${Math.random()}`
        }
        console.log('Yet Data URI', url)
        let res = await axios({
            method: method,
            data: data,
            url: url
        })
        if(opt.debug)console.log(`REQ: ${url}`,res,opt);
        return Promise.resolve(res.data);
    }
    Vue.prototype.yet.dict = async(name)=>{
        let base_data_url = '/api/dict'
        let url = `${base_data_url}/${name}`
        let res = await axios({
            url: url
        })
        return Promise.resolve(res.data);
    }
    Vue.prototype.yet.user = ()=>{
        return store.state.user;
    }
    Vue.prototype.yet.role = (role)=>{
        // console.log(store.state.user)
        if(store.state.user && store.state.user.role){
            if(typeof(role) != 'string'){
                for(let r of role){
                    if(!store.state.user.role.find(ur=>ur.name==r)){
                        return false;
                    }
                }
                return true;
            }
            else{
                return store.state.user.role.find(ur=>ur.name==role)
            }
        }
        return false;
    }
    Vue.prototype.yet.pos = async (id,pos,global = false)=>{
        let format = 'user'
        if(global){
            format = 'global'
        }
        let res = await axios({
            method: 'PUT',
            url: `/api/data/pos/${id}/${pos}.${format}?${Math.random}`
        })
    }
    Vue.prototype.yet.delete = async(id)=>{
        await axios({
            method: 'DELETE',
            url: `/api/data/${id}`
        })
    }
    Vue.prototype.yet.update = async (schema, id, fields,onUploadProgress=null)=>{
        let fd = new FormData();
        fd.append('id', id);
        for(let f in fields){
            // console.log(f,fields[f]);
            fd.append(f, fields[f].toString());
        }
        let res = await axios({
            method: 'PUT',
            url: `/api/data/${schema}/?id=${id}`,
            data: fd,
            headers: {
                'Content-Type': 'multipart/form-data'
              },
            onUploadProgress: onUploadProgress
        })
        return Promise.resolve(res.data);
    }
    Vue.prototype.yet.new = async (schema, fields, onUploadProgress=null)=>{
        let fd = new FormData();
        // fd.append('id', id);
        for(let f in fields){
            // console.log(f,fields[f]);
            // console.log('YetDebug',f, fields[f],fields[f].name)
            if(fields[f].name){
                fd.append(f, fields[f],fields[f].name);
            }
            else{
                fd.append(f, fields[f].toString());
            }
        }
        let res = await axios({
            method: 'POST',
            url: `/api/data/${schema}/`,
            data: fd,
            headers: {
                'Content-Type': 'multipart/form-data'
              },
            onUploadProgress: onUploadProgress
        })
        return Promise.resolve(res.data);
    }
    Vue.prototype.yet.vote = async(votable_id, scope)=>{
        let res = await axios.post(`/api/data/vote/${scope}/${votable_id}`)
        return Promise.resolve(res.data)
    }
    Vue.prototype.yet.unvote= async(votable_id, scope)=>{
        let res = await axios.post(`/api/data/vote/${scope}/${votable_id}?cancel=true`)
        return Promise.resolve(res.data)
    }
    Vue.prototype.yet.getvote = async(votable_id, scope)=>{
        let res = await axios.get(`/api/data/vote/${scope}/${votable_id}?${Math.random()}`)
        return Promise.resolve(res.data.size)
    }
    Vue.prototype.yet.isvoted = async(votable_id, scope)=>{
        let res = await axios.get(`/api/data/vote_by/${scope}/${votable_id}?${Math.random()}`)
        return Promise.resolve(res.data.voted)
    }
}